const RemoteCollaboration = () => {
  return (
    <div className="container--blog_post_page_wrapper">
      <section className="container--blog_post">
        <div className="container--post_content">
          <p className="text--post_paragraph">
            Remote work is on the rise, making tools for remote collaboration a
            professional necessity. A recent study found that 83% of workers
            depend on technology to collaborate. Without the physical proximity
            or resources found in traditional office spaces, it is crucial to
            equip employees with the necessary tools to build teams and work
            together. This list of digital tools and online platforms helps
            create strong teams.
          </p>
          <h2 className="header header--page_title_h2_center">
            Teammate<span className="makeGreen">Me</span>
          </h2>
          <p className="text--post_paragraph">
            Collaboration starts with finding teammates. On Teammate
            <span className="makeGreen">Me</span>, you can find the right people
            all in one place. Teammate<span className="makeGreen">Me</span> is
            ideal for students, professors, professionals, and hobbyists.
            Users can request to join existing teams or create their own, for
            any purpose, from gaming to nonprofit ventures. A premier feature of
            Teammate<span className="makeGreen">Me</span> is the ability to rate
            each teammate you work with. These aggregate scores are public,
            making it easy to find teammates with a strong reputation.
          </p>
          <h2 className="header header--page_title_h2_center">GSuite</h2>
          <p className="text--post_paragraph">
            Once you have found teammates, you need a way to stay connected and
            organized. GSuite has everything needed, from email to file sharing
            to calendars. GSuite refers to Google Apps, which is Gmail (an email
            client), Google Drive (cloud-based + file storage and sharing),
            Google Forms (interactive form builder), Google Docs (a word
            processing platform), Google Sheets (a mathematical and calculation
            spreadsheet program), Google Calendar, and Google Hangouts (a
            messaging app).
          </p>
          <p className="text--post_paragraph">
            GSuite apps are simple to use and navigate and can be accessed from
            any mobile device or computer. Many of the GSuite apps are built for
            collaboration, allowing multiple users to edit a document or
            presentation.
          </p>
          <h2 className="header header--page_title_h2_center">Zoom</h2>
          <p className="text--post_paragraph">
            Phone and video conferences are effortless thanks to Zoom. This
            video conferencing system is both a desktop application and app,
            allowing users to join or host meetings from their phone, tablet,
            via apps, online, and through phone calls. The Zoom interface is
            simple but packed with features, such as background changing, screen
            sharing capabilities, and meeting chats. Zoom is suitable for any
            size meeting, from a party of two to a group of hundreds.
          </p>
          <h2 className="header header--page_title_h2_center">Time Doctor</h2>
          <p className="text--post_paragraph">
            In traditional office settings, managers often keep track of time
            and projects by physically overseeing teams and employees. With Time
            Doctor, there is a more efficient way to monitor progress. Time
            Doctor is an application that tracks how many hours your team
            worked. It has a robust reporting system, generating productivity
            reports for people, projects, and tasks. Time Doctor is also a
            unique efficiency program, giving users the chance to see where they
            spent the most time.
          </p>
          <h2 className="header header--page_title_h2_center">Canva</h2>
          <p className="text--post_paragraph">
            Canva is an integrated graphics platform with templates for social
            media posts, presentations, flyers, and more. The images are easily
            edited in the drag-and-drop style interface, meaning that anyone can
            create beautiful graphics. Canva has a large library of free
            templates that are ready for manipulation, and can be downloaded in
            a variety of file types. Since designs are often a collaborative
            effort for organizations, Canva allows files to be shared and edited
            by multiple users.
          </p>
          <h2 className="header header--page_title_h2_center">Asana</h2>
          <p className="text--post_paragraph">
            To stay organized, teams need a project management system, which is
            why one of the most crucial tools on this list is Asana. It is an
            online organizational tool where your team can map out the pipeline
            of a project, create tasks in the form of cards, and move them along
            the process. In each card, you can upload files, assign tasks, make
            comments, and have conversations along the way. The platform’s
            timeline feature helps keep tasks and projects on schedule. The
            Asana app will send updates, messages, and alerts, meaning you will
            never miss a notification.
          </p>
        </div>
        <hr className="hr--form_break" />
      </section>
    </div>
  );
};

export default RemoteCollaboration;
